/**
 * @file AiConsentRow.tsx
 * @brief Profile → Data & sharing: "How VERBLIZR uses AI · Agreed on <date>"
 *        with the text (B7 rule 4). No withdraw in v1 (DES to decide).
 *
 * @details
 * Not agreed yet: an "Agree" button opens the same sheet. Hidden while the
 * server has no answer (route not deployed yet, read error).
 *
 * @author DES (prepared with Claude)
 * @date 22-10-2026
 */

import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/Button";
import { formatDate } from "@/shared/utils/formatters";
import { agreedCaption } from "./aiConsent";
import { aiConsentKey, askForAiConsent, fetchAiConsentState } from "./consentBridge";

export function AiConsentRow() {
  const q = useQuery({
    queryKey: aiConsentKey,
    queryFn: fetchAiConsentState,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const state = q.data;
  if (!state) return null;

  return (
    <div className="flex items-start gap-3 border-b border-border/60 px-4 py-3.5 md:px-5">
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-medium">{state.wording.title}</span>
        <span className="block text-xs text-muted-foreground">{state.wording.body}</span>
        <span className="mt-1 block text-xs font-medium text-muted-foreground">
          {agreedCaption(state, (iso) => formatDate(iso))}
        </span>
        <a
          href={state.wording.privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 inline-block text-xs font-medium text-brand hover:underline"
        >
          Privacy policy
        </a>
      </span>
      {!state.accepted ? (
        <Button type="button" size="sm" variant="outline" onClick={() => void askForAiConsent(state.wording)}>
          {state.wording.agreeLabel}
        </Button>
      ) : null}
    </div>
  );
}
